import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { selectQueryParams, selectRouteParams } from './router.selectors';

@Injectable({ providedIn: 'root' })
export class RouterStore {
  constructor(private store: Store) {}

  selectQueryParams$ = this.store.select(selectQueryParams);
  selectRouteParams$ = this.store.select(selectRouteParams);
}
